import { setIsFreeView } from 'library-@/utils/patent-view-free-judgment-util.js';
import { startup } from 'library-@/startup/index.js';
import { headerService } from '@/services/header-service';
import { ejectCommonInterceptor } from './eject-common-interceptor';
import { injectFreeViewInterceptor } from './inject-free-view-interceptor';

export async function startupFreeView(forceSetLocale?: string) {
    // 在别的产品登录 无法清除analytics域下的token 确保free下去除默认内置拦截器
    ejectCommonInterceptor();
    // 必须先设置IsFree状态
    setIsFreeView(true);

    const [, locale, , commonInitData, , legalConfig] = await startup({
        isFreeView: true,
        headerService,
        projectName: 'Patent View',
        pageInit: () => ({}),
        redirect: '/request_demo?project=search',
        forceSetLocale: forceSetLocale,
    });

    // 注册freeView专属拦截器
    injectFreeViewInterceptor(locale);

    return {
        commonInitData,
        locale,
        legalConfig,
    };
}
